module.exports = __webpack_public_path__ + "static/media/church-x.5ae4e9d2.svg";